/**
 * API base URL for fetch calls. Uses REACT_APP_API_URL at build time, or same-origin /api in production.
 */
export function getApiBaseUrl() {
  const env = process.env.REACT_APP_API_URL;
  if (env && String(env).trim()) {
    return String(env).replace(/\/$/, '');
  }
  if (
    typeof window !== 'undefined' &&
    window.location?.hostname &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
  ) {
    return `${window.location.origin}/api`;
  }
  return 'http://localhost:5001/api';
}

/** Origin of the API (for static assets like /uploads/...) */
export function getApiOrigin() {
  try {
    return new URL(getApiBaseUrl()).origin;
  } catch {
    return typeof window !== 'undefined' ? window.location.origin : '';
  }
}
